export default __webpack_public_path__ + "img/Productos.4f9371b8.jpg";